// documentsApi.js - Dokument i patientjournalen (Spår D)
import apiClient from '../../apiClient';

const BASE = '/api/documents';

export const KIND_LABELS = { upload: 'Uppladdat', written: 'Skrivet' };
export const SOURCE_LABELS = { upload: 'Uppladdning', template: 'Mall', manual: 'Fritext', ai: 'AI-utkast' };
export const CATEGORY_LABELS = { intyg: 'Intyg', remiss: 'Remiss', brev: 'Brev', ovrigt: 'Övrigt' };

export const ACCEPTED_UPLOAD_TYPES = 'application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png';
export const MAX_UPLOAD_MB = 20;

export const getPatientDocuments = async (patientId, params = {}) => {
  const response = await apiClient.get(`${BASE}/patients/${patientId}`, { params });
  return response.data;
};

export const uploadDocument = async (patientId, { file, title, documentDate, appointmentId }) => {
  const form = new FormData();
  form.append('file', file);
  if (title) form.append('title', title);
  if (documentDate) form.append('document_date', documentDate);
  if (appointmentId) form.append('appointment_id', appointmentId);
  const response = await apiClient.post(`${BASE}/patients/${patientId}/upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const createWrittenDocument = async (patientId, payload) => {
  const response = await apiClient.post(`${BASE}/patients/${patientId}/written`, payload);
  return response.data;
};

export const getDocument = async (documentId) => {
  const response = await apiClient.get(`${BASE}/${documentId}`);
  return response.data;
};

export const updateDocument = async (documentId, payload) => {
  const response = await apiClient.put(`${BASE}/${documentId}`, payload);
  return response.data;
};

export const signDocument = async (documentId, payload) => {
  const response = await apiClient.post(`${BASE}/${documentId}/sign`, payload);
  return response.data;
};

export const voidDocument = async (documentId, reason) => {
  const response = await apiClient.post(`${BASE}/${documentId}/void`, { reason });
  return response.data;
};

export const getDocumentAuditLog = async (documentId) => {
  const response = await apiClient.get(`${BASE}/${documentId}/audit-log`);
  return response.data;
};

/** Hämta filen som Blob (filen kräver JWT, så den kan inte länkas direkt). */
export const fetchDocumentBlob = async (documentId, { download = false } = {}) => {
  const response = await apiClient.get(`${BASE}/${documentId}/file`, {
    params: download ? { download: 1 } : {},
    responseType: 'blob',
  });
  return response.data;
};

export const getDocumentTemplates = async () => {
  const response = await apiClient.get('/api/document-templates');
  return response.data;
};

/** Fel från axios med blob-svar: läs ut JSON-felet. */
export const errorMessage = async (err, fallback) => {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text()).error || fallback;
    } catch {
      return fallback;
    }
  }
  return data?.error || data?.msg || fallback;
};
